import styled from 'styled-components';
import { colors, font } from '@chegg-ui/theme';
var dark = colors.dark;
var family = font.family,
  weight = font.weight,
  size = font.size;
export var PaymentOptionsContainer = styled.div.withConfig({
  componentId: "sc-1ks68nx-0"
})(["outline:none;"]);
export var PaymentTopHeader = styled.h2.withConfig({
  componentId: "sc-1ks68nx-1"
})(["color:", ";font-family:", ";font-weight:", ";margin:0 0 10px 0;font-size:", ";"], dark, family.aspira, weight.bold, size.px18);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/PaymentViews/styled.js
// module id = 893
// module chunks = 11